import { AttributeModel } from './attribute.model';

export class SubCategory {
    _id: string;
    subCategoryName: string;
    subCategoryDescription: string;
    metaTagTitle: string;
    status: string;
    metaTagDescription: string;
    subCategoryImageName: string;
    metaTagKeyword: string;
    count: number;
    attribute: [AttributeModel];
    urlLink: string;
}
